export default __webpack_public_path__ + "static/media/logo.c08af680.png";